<script lang="ts">
  import {ResiPlaylist} from '@/types/integrations';
  import MediaCard from './MediaCard.svelte';
  import MediaCardSkeleton from './MediaCardSkeleton.svelte';
  import SearchInput from './SearchInput.svelte';

  export let allPlaylistAsync: Promise<ResiPlaylist[]>;

  let filterText = '';
</script>

<div>
  <div class="mb-4 flex items-center justify-between gap-x-6">
    <h1 class="truncate text-xl font-bold">All Playlists</h1>
    <SearchInput bind:value={filterText} placeholder="Search for a playlist" />
  </div>
  <ul class="grid max-h-[430px] min-h-[430px] grid-cols-3 gap-3 overflow-y-auto">
    {#await allPlaylistAsync}
      <MediaCardSkeleton />
    {:then playlists}
      {#each playlists.filter(p => p.name.toLowerCase().includes(filterText.toLowerCase())) as playlist (playlist.id)}
        <MediaCard item={playlist} on:click />
      {/each}
    {/await}
  </ul>
</div>
